import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[click-trigger]',
})
export class ClickTrigger {

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {
  }

  @HostListener('keydown', ['$event'])
  keyEvent(_keyEvent: KeyboardEvent) {

    const $element = this.el.nativeElement;
    const keyCode = _keyEvent.which || _keyEvent.keyCode;

    if (keyCode == 13 || keyCode == 32) {
      _keyEvent.preventDefault();

      const labelTarget = $element.getAttribute('for');
      const triggerTarget = $element.getAttribute('data-click-trigger-target');

      if (labelTarget) {

        /*
         * Angular have an issue that not allows to call ng method programmatically at once triggered event.
         */

        const $target = document.querySelector('#' + labelTarget);
        const isChecked = $target['checked'];
        const isRadio = $target.getAttribute('type') === 'radio';

        if (isRadio) {
          this.renderer.setProperty($target, 'checked', 'checked');
          setTimeout(() =>  $element.focus(), 100);
        } else {
          this.renderer.setProperty($target, 'checked', !isChecked);
        }
        $target.dispatchEvent(new Event('change', {bubbles: true, cancelable: true}));
      } else if (triggerTarget) {
        const $target = document.querySelector('[data-click-trigger-source="' + triggerTarget + '"]');
        $target.dispatchEvent(new Event('click', {bubbles: true, cancelable: true}));
      } else {
        $element.dispatchEvent(new Event('click', {bubbles: true, cancelable: true}));
      }
    }
  }
}





